export default "__VITE_ASSET__C$w2laeu__"